import { v4 as uuid, validate as validateUuid } from 'uuid'

export interface SavedState {
	pathname: string
	search: string
}

export const saveState = ({ pathname, search }: SavedState): string => {
	const json = JSON.stringify({ pathname, search })

	if (!isPathInWhiteUnsecureList(pathname)) {
		const key = uuid()

		sessionStorage.setItem(key, json)

		return btoa(key)
	} else {
		return btoa(json)
	}
}

export const isSaveStateKeyValid = (encodedValue: string) => {
	const decodedValue = atob(encodedValue)

	if (validateUuid(decodedValue)) {
		return !!sessionStorage.getItem(decodedValue)
	} else {
		let data: SavedState
		try {
			data = JSON.parse(decodedValue)
			return isPathInWhiteUnsecureList(data.pathname)
		} catch {
			return false
		}
	}
}

export const getSavedState = (encodedValue: string): SavedState | null => {
	const decodedValue = atob(encodedValue)

	if (validateUuid(decodedValue)) {
		const data = sessionStorage.getItem(decodedValue)

		if (data) {
			return JSON.parse(data)
		}
	} else {
		try {
			return JSON.parse(decodedValue)
		} catch {}
	}

	return null
}

const WHITE_UNSECURE_LIST = ['/onboarding']

const isPathInWhiteUnsecureList = (pathname: string) => {
	return WHITE_UNSECURE_LIST.includes(pathname)
}
